/**
 * Admin API client for dashboard statistics.
 *
 * @module adminApi
 */

import { apiGet } from '@/lib/apiUtils';

export interface AdminDashboardStats {
  readonly totalQuestions: number;
  readonly totalContexts: number;
  readonly activeUsers: number;
  readonly levelDistribution: ReadonlyArray<{
    readonly level: string;
    readonly count: number;
  }>;
  readonly calculatedTotal: number;
  readonly questionsThisWeek?: number;
}

export async function getAdminDashboardStats(): Promise<AdminDashboardStats | null> {
  return apiGet<AdminDashboardStats>('/admin/stats', {
    context: 'getAdminDashboardStats',
  });
}
